import { useEffect, useRef, useState } from "react";
import type { EnquiryKind } from "../../config/contact";
import { Icon } from "../ui/Icon";
import { EnquiryForm, type EnquiryValues } from "./EnquiryForm";

export function EnquiryDialog({ open, onClose, title, kind, initialValues, lockProduct }: {
  open: boolean; onClose: () => void; title: string; kind: EnquiryKind; initialValues?: EnquiryValues; lockProduct?: boolean;
}) {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!open) return;
    const dialog = dialogRef.current!;
    const previousOverflow = document.body.style.overflow;
    const previousFocus = document.activeElement as HTMLElement | null;
    document.body.style.overflow = "hidden";
    dialog.showModal();
    return () => {
      dialog.close();
      document.body.style.overflow = previousOverflow;
      previousFocus?.focus();
    };
  }, [open]);
  if (!open) return null;
  return <dialog ref={dialogRef} className="contact-dialog rfq-dialog enquiry-dialog" aria-labelledby={`enquiry-title-${kind}`} onCancel={(event) => { event.preventDefault(); if (!busy) onClose(); }}>
    <button className="dialog-close" type="button" aria-label="Close enquiry form" disabled={busy} onClick={onClose}><Icon name="x" size={20} /></button>
    <p className="section-kicker">{kind === "partnership" ? "Export development" : "Product sourcing"}</p>
    <h2 id={`enquiry-title-${kind}`}>{title}</h2>
    <p>Share your requirements and contact details. You can attach specifications, product photos or a company profile.</p>
    <EnquiryForm kind={kind} initialValues={initialValues} lockProduct={lockProduct} onBusyChange={setBusy} />
  </dialog>;
}
